import { render, staticRenderFns } from "./batch-update-device.vue?vue&type=template&id=2dc2ca61&scoped=true&"
import script from "./batch-update-device.vue?vue&type=script&lang=js&"
export * from "./batch-update-device.vue?vue&type=script&lang=js&"
import style0 from "./batch-update-device.vue?vue&type=style&index=0&id=2dc2ca61&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc2ca61",
  null
  
)

export default component.exports